import { CommonModule, DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Component, computed, DestroyRef, ElementRef, inject, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, signal, viewChild, ViewChild, ViewContainerRef } from "@angular/core";
import { Router, RouterModule } from "@angular/router";

import { SocialAuthService } from "@abacritt/angularx-social-login";
import { AgentComponent } from "app/registration/agent/agent.component";
import { UserComponent } from "app/registration/user/user.component";
import { DialogService, DynamicDialogModule, DynamicDialogRef } from "primeng/dynamicdialog";
import { share } from "rxjs/operators";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { CommonService } from "@services/common.service";
import { YTBSEOService } from "@services/ytb-seo.service";

// import { componentDestroyed } from 'ng2-rx-componentdestroyed';
import { LoginService } from "../../../services/auth.service";
import { SharedService } from "../../../services/shared.service";
import { UserSignupComponent } from "app/registration/usersignup/usersignup.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { AuthenticationModule } from "@auth/authentication.module";
import { DropdownlistModule } from "controls";
import * as UAParser from "ua-parser-js";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

declare var jQuery: any;

@UntilDestroy()
@Component({
  selector: "app-header-page",
  templateUrl: "./header-page.component.html",
  styleUrls: ["./header-page.component.scss"],
  providers: [DialogService],
  standalone: true,
  imports: [CommonModule, AuthenticationModule, DropdownlistModule, RouterModule, ReactiveFormsModule, FormsModule, DynamicDialogModule],
})
export class HeaderPageComponent implements OnInit, OnDestroy {
  // @ViewChild("button") private button: ElementRef;
  // @ViewChild("closeMenuButton") private closeMenuButton: ElementRef;
  // @ViewChild("closebtn") closebtn;

  // @ViewChild("hidecurrency")
  // private hidecurrency: ElementRef;
  // ref: DynamicDialogRef | undefined;
  // enableLoginBtn: boolean = true;
  // enableMyAccount: boolean = false;
  // languagesData: Array<any> = [];
  // currencys: Array<any> = [];
  // currentCurrency: String;
  // currenctLanguage: String;
  // popularCurrencys: Array<any> = [];
  // normalCurrencys: Array<any> = [];
  // showSuccess: boolean;
  // OAuthSecretCodes: any = {};
  // geoLocationResponse: Array<any> = [];
  // geoLocationInfo: any = {};
  // previousCurrency: String;
  // fetchIpAddressUrl: string;
  // rememberMeDataAvailable: any = {};
  // token: string;
  // popularCurrencysDropdown: Array<any> = [];
  // selectedGroup: any;

  // deviceInfo: any = {};
  // isMobile: boolean = true;
  // isDisableCurrency: boolean = false;
  // contactDetails: Array<any>;
  // mobileArr: Array<any>;
  // tempReferenceId: any;
  // ipAddress: any;

  // constructor(
  //   private renderer: Renderer2,
  //   @Inject(DOCUMENT) private document,
  //   private commonService: CommonService,
  //   private LoginService: LoginService,
  //   private sharedService: SharedService,
  //   private router: Router,
  //   private ytbseoService: YTBSEOService,
  //   private authService: SocialAuthService,
  //   private deviceService: DeviceDetectorService,
  //   @Inject(PLATFORM_ID) private platformId,
  //   public dialogService: DialogService,
  // ) {}

  // ViewChild Signals
  readonly button = viewChild<ElementRef<HTMLButtonElement>>("button");
  readonly closeMenuButton = viewChild<ElementRef<HTMLElement>>("closeMenuButton");
  readonly closebtn = viewChild<ElementRef<HTMLElement>>("closebtn");
  readonly hidecurrency = viewChild<ElementRef<HTMLElement>>("hidecurrency");

  // State Signals
  readonly ref = signal<DynamicDialogRef | undefined>(undefined);

  readonly enableLoginBtn = signal(true);
  readonly enableMyAccount = signal(false);

  readonly languagesData = signal<any[]>([]);
  readonly currencys = signal<any[]>([]);

  readonly currentCurrency = signal<string>("");
  readonly currenctLanguage = signal<string>("English");

  readonly popularCurrencys = signal<any[]>([]);
  readonly normalCurrencys = signal<any[]>([]);

  readonly showSuccess = signal(false);

  readonly OAuthSecretCodes = signal<Record<string, any>>({});

  readonly geoLocationResponse = signal<any[]>([]);
  readonly geoLocationInfo = signal<Record<string, any>>({});

  readonly previousCurrency = signal<string>("");

  readonly fetchIpAddressUrl = signal<string>("");

  readonly rememberMeDataAvailable = signal<Record<string, any>>({});

  readonly token = signal<string>("");

  readonly popularCurrencysDropdown = signal<any[]>([]);

  readonly selectedGroup = signal<any | null>(null);

  readonly deviceInfo = signal<Record<string, any>>({});

  readonly isMobile = signal(true);

  readonly isDisableCurrency = signal(false);

  readonly contactDetails = signal<any[]>([]);

  readonly mobileArr = signal<any[]>([]);

  readonly tempReferenceId = signal<any>(null);

  readonly ipAddress = signal<any>(null);

  private readonly commonService = inject(CommonService);
  private readonly router = inject(Router);
  private readonly sharedService = inject(SharedService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialogService = inject(DialogService);
  private readonly renderer = inject(Renderer2);
  private readonly deviceService = inject(DeviceDetectorService);
  private readonly authService = inject(SocialAuthService);
  private readonly loginService = inject(LoginService);
  private readonly ytbseoService = inject(YTBSEOService);

  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);
  readonly currencyDisplay = computed(() => `${this.currentCurrency()} / ${this.currenctLanguage()}`);

  ngOnInit(): void {
    this.sharedService.currenctCurrencyParam$.subscribe((curr) => {
      if (curr) {
        this.currentCurrency.set(curr);
      }
    });
    this.initializeData();
    this.initializeBrowser();
    this.initializeSubscriptions();
  }

  private initializeData(): void {
    this.commonService.getSupplierManagerMappingDetails();
    this.commonService.getAllCurrency();

    this.epicFunction();

    this.getLanguagges();

    this.getCurrencyList();
    this.myBrowser();
  }

  private initializeBrowser(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const parser = new UAParser.UAParser();

    const cpu = parser.getCPU();

    const userAgent = {
      browser: parser.getBrowser(),
      os: parser.getOS(),
      platform: {
        type: cpu?.architecture,
      },
    };

    this.sharedService.setBrowserInformationInStorage(userAgent);
  }

  private initializeSubscriptions(): void {
    this.sharedService.closeReferenceFromOtherFiles.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      if (this.ref()) {
        this.ref().close();
      }
    });

    this.commonService.CurrencyList.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((currencylist) => {
      console.log(currencylist, "   nagaraju ");
    });

    this.commonService.ORGDETAILSHOME.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((contactDetails) => {
      if (contactDetails && contactDetails.result) {
        console.log(contactDetails.result, "  nagaraju");
        this.contactDetails.set(contactDetails.result);
        this.mobileArr.set(this.contactDetails().filter((item) => item.contactTypeCode === "PH" && item.phoneTypeCode === 4));
      }
    });

    this.commonService.SupplierManagerMappingDetails.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((mappings) => {
      if (mappings) {
        let Credentials: Array<any> = mappings.result;
        let index = Credentials.findIndex((i) => i.name == "facebook");
        let indx = Credentials.findIndex((i) => i.name == "google");
        this.OAuthSecretCodes().google = Credentials[indx].value;
        this.OAuthSecretCodes().facebook = Credentials[index].value;

        this.fetchIpAddressUrl.set(Credentials[Credentials.findIndex((i) => i.name === "geopluginurl")].value);
        this.sharedService.sendIPUrl(this.fetchIpAddressUrl());

        if (this.tempReferenceId()) {
          setTimeout(() => {
            this.commonService.logError({
              loglevel: "Info",
              message: " IpAddress for user -   " + this.tempReferenceId() + JSON.stringify(this.fetchIpAddressUrl()),
            });
          }, 200);
        }
        console.log(this.ipAddress(), "   inside of ipaddress ");
        if (!this.ipAddress()) {
          this.commonService.getDatausingGeoPlugin(Credentials[Credentials.findIndex((i) => i.name === "geopluginurl")].value);
        }
      }
    });

    this.sharedService.userDetailsParam.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((userDataObj) => {
      if (userDataObj != null && userDataObj != undefined) {
        if (userDataObj) {
          this.enableMyAccount.set(true);
          this.enableLoginBtn.set(false);
          this.sharedService.setUserIdAfterLogin(userDataObj.username);
        } else {
          this.enableMyAccount.set(false);
          this.enableLoginBtn.set(true);
        }
      }
    });

    this.sharedService.clientUserIp$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((ipAddrObj) => {
      if (ipAddrObj) {
        this.ipAddress.set(ipAddrObj);
      }
    });

    this.commonService.PopularCurrencyList.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((currencyList) => {
      console.log(currencyList, "@@@@@@@@@@@@@ naaaaa");

      if (!currencyList?.result) {
        return;
      }

      // this.normalCurrencys.set(currencyList.result.normalcurrency);

      this.popularCurrencys.set(currencyList.result.popularcurrency);

      this.popularCurrencysDropdown.set(this.commonService.prepareCurrencyDropdownResponse(this.popularCurrencys(), "curreny", "symbol"));

      const index = this.normalCurrencys().findIndex((item) => item.symbol === this.currentCurrency());

      const finalIndex = this.popularCurrencys().findIndex((item) => item.symbol === this.currentCurrency());

      console.log(`${this.currentCurrency()} / ${this.currenctLanguage()}`, "nagaraju");

      this.selectedGroup.set(this.popularCurrencysDropdown().find((x) => x.value === this.currentCurrency()) ?? null);
    });

    this.sharedService.tempReferenceID$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((refID) => {
      if (refID != null && refID != "" && refID != undefined) {
        this.tempReferenceId.set(refID);
      } else {
      }
    });

    this.commonService.onFailure.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
      console.log(JSON.stringify(response), "  At On Failure ");
      if (response) {
        if (response.exceptionSource == "IPSSLGET_FAILURE") {
          this.commonService.getDataUsingIpstackPlugin();
        } else if (response.exceptionSource == "APIIPIFY_FAILURE") {
          this.commonService.getDatausingGeoPlugin(this.fetchIpAddressUrl);
        }
      }
    });

    this.commonService.GetIPAddressIPIFYSUCCESS.subscribe((param) => {
      if (param) {
        this.sharedService.setClientIpIn(param.ip);
      }
    });

    this.commonService.GetAddressFromIPAddress.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (!params) return;

      console.log(params, "nagaraju");

      setTimeout(() => {
        this.commonService.logError({
          loglevel: "Info",
          message: "Get Ip Address response Header Page - " + this.tempReferenceId() + JSON.stringify(params),
        });
      }, 200);

      let geoData = params;

      if (!geoData.geoplugin_request && (geoData.ip || geoData.success)) {
        geoData = {
          geoplugin_request: geoData.ip || "",
          geoplugin_status: geoData.success ? 200 : 404,
          geoplugin_city: geoData.city || "",
          geoplugin_region: geoData.region || "",
          geoplugin_regionName: geoData.region || "",
          geoplugin_regionCode: geoData.region_code || "",
          geoplugin_countryName: geoData.country || "",
          geoplugin_countryCode: geoData.country_code || "",
          geoplugin_currencyCode: geoData.currency || "USD",
          geoplugin_latitude: geoData.latitude || "",
          geoplugin_longitude: geoData.longitude || "",
          geoplugin_timezone: geoData.timezone || "",
        };
      } else {
        geoData = {
          geoplugin_request: "103.229.129.140",
          geoplugin_city: "Jacksonville",
          geoplugin_countryName: "United States",
          geoplugin_countryCode: "US",
          geoplugin_currencyCode: "USD",
        };
      }

      this.sharedService.setClientIpIn(geoData.geoplugin_request);

      this.geoLocationInfo.set({
        countryName: geoData.geoplugin_countryName,
        countryCode: geoData.geoplugin_countryCode,
        cityName: geoData.geoplugin_city,
        currencyCode: geoData.geoplugin_currencyCode,
        geoPluginCode: 1,
      });

      this.sharedService.setGeoLocationParams(this.geoLocationInfo());
      if (!this.currentCurrency()) {
        this.sharedService.setCurrentCurrency(this.geoLocationInfo().currencyCode);
      }

      this.selectedGroup.set(this.popularCurrencysDropdown().find((x) => x.value === this.geoLocationInfo().currencyCode) ?? null);

      this.sharedService.setCurrencyInPages();

      this.getOrgContactDetails(this.geoLocationInfo().countryCode);
    });

    this.sharedService.loginSuccess$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((status) => {
      if (status == null) return;

      this.enableLoginBtn.set(status);
      this.enableMyAccount.set(true);
    });

    this.sharedService.GeoLocationParam.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((geoData) => {
      if (!geoData) return;

      this.geoLocationInfo.set(geoData);

      this.commonService.getContactUsDetails({
        countryISO2: this.geoLocationInfo().countryCode || "US",
      });
    });

    this.loginService.LanguaggeSuccess.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
      if (!result) return;

      this.languagesData.set(result.result);
    });

    this.commonService.CurrencyCountryIso2.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((currency) => {
      if (!currency?.result?.length) return;

      this.geoLocationInfo.update((info) => ({
        ...info,
        currencyCode: currency.result[0].shortname,
      }));

      this.sharedService.setGeoLocationParams(this.geoLocationInfo());

      this.selectedGroup.set(this.popularCurrencysDropdown().find((x) => x.value === this.geoLocationInfo().currencyCode) ?? null);

      console.log("inside of before set currency nagaraju");
      if (!this.currentCurrency()) {
        this.sharedService.setCurrentCurrency(this.geoLocationInfo().currencyCode);
      }
      if (this.selectedGroup()) {
        console.log(`${this.geoLocationInfo().currencyCode} / ${this.currenctLanguage()}`);
      }

      this.sharedService.setCurrencyInPages();
    });

    this.commonService.OrgContactSuccess$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((orgDtls) => {
      if (!orgDtls) return;

      this.ytbseoService.setOrgContactMetaDtls(orgDtls.result);
    });

    this.sharedService.previousCurrencyParam$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((currency) => {
      if (!currency) return;

      this.previousCurrency.set(currency);
    });

    this.sharedService.currenctCurrencyParam$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((currency) => {
      if (!currency) return;

      console.log("Current Currency:", currency);

      this.currentCurrency.set(currency);
    });

    this.sharedService.tempcurencySet$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.setCurrencyText(this.currentCurrency(), "");
    });

    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setTimeout(() => {
              this.commonService.logError({
                logLevel: "Info",
                message: "Enabled Location " + this.tempReferenceId() + JSON.stringify(position),
              });
            }, 200);

            this.displayLocationInfo(position);
          },
          (error) => {
            setTimeout(() => {
              this.commonService.logError({
                logLevel: "Info",
                message: "Disabled Location " + this.tempReferenceId() + JSON.stringify(error),
              });
            }, 200);

            this.commonService.getCurrencybyCountryIso2(this.geoLocationInfo().countryCode);

            this.geoLocationInfo.update((info) => ({
              ...info,
              countryCode: "US",
              countryName: "United States",
              cityname: "Jacksonville",
              geoPluginCode: 2,
            }));

            this.sharedService.setGeoLocationParams(this.geoLocationInfo());
            if (!this.currentCurrency()) {
              this.sharedService.setCurrentCurrency(this.geoLocationInfo().currencyCode);
            }
            this.sharedService.setCurrencyInPages();

            this.getOrgContactDetails(this.geoLocationInfo().countryCode);

            this.commonService.getCurrencybyCountryIso2(this.geoLocationInfo().countryCode);

            switch (error.code) {
              case 1:
                // Permission Denied
                break;

              case 2:
                // Position Unavailable
                break;

              case 3:
                // Timeout
                break;
            }
          },
        );
      } else {
        this.commonService.getCurrencybyCountryIso2(this.geoLocationInfo().countryCode);

        this.geoLocationInfo.update((info) => ({
          ...info,
          geoPluginCode: 2,
        }));
      }
    }

    this.sharedService.logOutUserId.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((status) => {
      if (!status) return;

      this.sharedService.setUserIdAfterLogin(null);

      this.sharedService.removeUserObject();

      this.enableLoginBtn.set(true);
      this.enableMyAccount.set(false);

      this.authService.signOut();

      if (this.router.url === "/my-account" || this.router.url === "/change-password") {
        this.router.navigate([""]);
      } else {
        this.router.navigate([""]);
      }
    });

    this.commonService.token$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((token) => {
      if (!token) return;

      this.token.set(token);

      this.sharedService.setToken(token);
    });

    this.sharedService.closeModalWindowAfterLogin$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((token) => {
      if (!token) return;

      this.ref()?.close();
    });

    this.sharedService.closeMenuFromOtherService$.pipe(untilDestroyed(this), share()).subscribe((status) => {
      if (status != null && status != undefined) {
        this.closeMenuButtonFromOthers();
      }
    });

    this.sharedService.navigateToSignupFromSigningPage.pipe(untilDestroyed(this)).subscribe((browser) => {
      console.log(browser, "   576 ");
      if (browser) {
        this.goToRegister();
      }
    });

    this.sharedService.navigateToAgentSignupFromSigningPage.pipe(untilDestroyed(this)).subscribe((browser) => {
      console.log(browser, "   622 ");
      if (browser) {
        this.gotoAgentSignup();
      }
    });

    this.sharedService.navigateToSigninFromSignupPage.pipe(untilDestroyed(this)).subscribe((browser) => {
      console.log(browser, "   585 ");
      if (browser) {
        // console.log("  Sign up to sign in    ");
        this.loadSignInComponent();
      }
    });
  }

  // ngOnInit2() {
  //   /**
  //    * This function is used to set languagge
  //    */

  //   // this.sharedService.loginUserId$
  //   //   .pipe(untilDestroyed(this), share())
  //   //   .subscribe((userId) => {
  //   //     if (userId != null && userId != undefined) {
  //   //       this.enableLoginBtn = false;
  //   //     }
  //   //   });

  //   // this.sharedService.userLoggedInParam
  //   //   .pipe(untilDestroyed(this), share())
  //   //   .subscribe((userId) => {
  //   //     if (userId != null && userId != undefined) {
  //   //       this.enableLoginBtn = false;
  //   //     }
  //   //   });

  //   this.sharedService.userDetailsParam
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((userDataObj) => {
  //       if (userDataObj != null && userDataObj != undefined) {
  //         if (userDataObj) {
  //           this.enableMyAccount = true;
  //           this.enableLoginBtn = false;
  //           this.sharedService.setUserIdAfterLogin(userDataObj.username);
  //         } else {
  //           this.enableMyAccount = false;
  //           this.enableLoginBtn = true;
  //         }
  //       }
  //     });

  //   this.sharedService.clientUserIp$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((ipAddrObj) => {
  //       if (ipAddrObj) {
  //         this.ipAddress = ipAddrObj;
  //       }
  //     });

  //   //check user exist from session
  //   // if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
  //   //   let userobj = localStorage.getItem('LoggegIn');

  //   //   let userDataObj = JSON.parse(localStorage.getItem('UserObj'));
  //   //   // localStorage.setItem('UserObj', localStorage.getItem('UserObj'));
  //   //   if (userDataObj) {
  //   //     localStorage.setItem('UserID', userDataObj.userName);
  //   //     this.enableMyAccount = true;
  //   //     this.enableLoginBtn = false;
  //   //   } else {
  //   //     this.enableMyAccount = false;
  //   //     this.enableLoginBtn = true;
  //   //   }

  //   //   if (userobj) {
  //   //     this.enableLoginBtn = false;
  //   //   }
  //   // }

  //   /**
  //    * This function is used to set currency value which is selected by user.
  //    */
  //   this.commonService.PopularCurrencyList.pipe(
  //     untilDestroyed(this),
  //     share(),
  //   ).subscribe((currencylist) => {
  //     console.log(currencylist, "  @@@@@@@@@@@@@ naaaaa");
  //     if (currencylist && currencylist.result) {
  //       // this.normalCurrencys = currencylist.result.normalcurrency;
  //       this.popularCurrencys = currencylist.result.popularcurrency;

  //       this.popularCurrencysDropdown =
  //         this.commonService.prepareCurrencyDropdownResponse(
  //           this.popularCurrencys,
  //           "curreny",
  //           "symbol",
  //         );

  //       let index, finalindex;

  //       index = this.normalCurrencys.findIndex(
  //         (item) => item.symbol === this.currentCurrency,
  //       );
  //       finalindex = this.popularCurrencys.findIndex(
  //         (item) => item.symbol === this.currentCurrency,
  //       );

  //       if (index >= 0) {
  //         console.log(
  //           this.currentCurrency + " / " + this.currenctLanguage,
  //           "   nagaraju",
  //         );

  //         // this.renderer.setProperty(
  //         //   this.button.nativeElement,
  //         //   "textContent",
  //         //   this.currentCurrency + " / " + this.currenctLanguage
  //         // );

  //         this.selectedGroup = this.popularCurrencysDropdown.find(
  //           (x) => x.value == this.currentCurrency,
  //         );
  //         // console.log(this.selectedGroup);
  //       } else {
  //         console.log(
  //           this.currentCurrency + " / " + this.currenctLanguage,
  //           "   nagaraju",
  //         );

  //         // this.renderer.setProperty(
  //         //   this.button.nativeElement,
  //         //   "textContent",

  //         //   this.currentCurrency + " / " + this.currenctLanguage
  //         // );

  //         this.selectedGroup = this.popularCurrencysDropdown.find(
  //           (x) => x.value == this.currentCurrency,
  //         );
  //         // console.log(this.selectedGroup);
  //       }
  //     }
  //   });

  //   /**
  //    * This function is used to get Geo address from IP Address
  //    */
  //   // this.commonService.GetIpAddressUsingGeoPlugin.subscribe((params) => {
  //   //   if (params) {
  //   // this.commonService.SupplierManagerMappingDetails.pipe(
  //   //   untilDestroyed(this)
  //   // ).subscribe((mappings) => {
  //   //   if (mappings) {
  //   //     let Credentials: Array<any> = mappings.result;
  //   //     this.fetchIpAddressUrl =
  //   //       Credentials[
  //   //         Credentials.findIndex((i) => i.name === "geopluginurl")
  //   //       ].value;

  //   //     let key =
  //   //       Credentials[Credentials.findIndex((i) => i.name === "geopluginurl")]
  //   //         .value;

  //   //     console.log(this.fetchIpAddressUrl, key, "  nagaraju");
  //   //     if (this.tempReferenceId)
  //   //       setTimeout(() => {
  //   //         this.commonService.logError({
  //   //           loglevel: "Info",
  //   //           message:
  //   //             " IpAddress for user -   " +
  //   //             this.tempReferenceId +
  //   //             JSON.stringify(this.fetchIpAddressUrl),
  //   //         });
  //   //       }, 200);
  //   //     if (this.ipAddress) {
  //   //       this.commonService.getDatausingGeoPlugin(
  //   //         Credentials[Credentials.findIndex((i) => i.name === "geopluginurl")]
  //   //           .value
  //   //       );
  //   //     }
  //   //   }
  //   // });
  //   //   }
  //   // });

  //   this.sharedService.tempReferenceID$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((refID) => {
  //       if (refID != null && refID != "" && refID != undefined) {
  //         this.tempReferenceId = refID;
  //       } else {
  //       }
  //     });

  //   this.commonService.onFailure
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((response) => {
  //       console.log(JSON.stringify(response), "  At On Failure ");
  //       if (response) {
  //         if (response.exceptionSource == "IPSSLGET_FAILURE") {
  //           this.commonService.getDataUsingIpstackPlugin();
  //         } else if (response.exceptionSource == "APIIPIFY_FAILURE") {
  //           this.commonService.getDatausingGeoPlugin(this.fetchIpAddressUrl);
  //         }
  //       }
  //     });

  //   this.commonService.GetIPAddressIPIFYSUCCESS.subscribe((param) => {
  //     if (param) {
  //       this.sharedService.setClientIpIn(param.ip);
  //     }
  //   });

  //   /**
  //    * This function is used to fetching address from IP Address and store it in session
  //    */
  //   this.commonService.GetAddressFromIPAddress.subscribe((params) => {
  //     if (params) {
  //       console.log(params, "  nagaraju");
  //       setTimeout(() => {
  //         this.commonService.logError({
  //           loglevel: "Info",
  //           message:
  //             " Get Ip Address response Header Page  -   " +
  //             this.tempReferenceId +
  //             JSON.stringify(params),
  //         });
  //       }, 200);

  //       if (!params.geoplugin_request && (params.ip || params.success)) {
  //         const formatGeoPlugin = (data) => ({
  //           geoplugin_request: data.ip || "",
  //           geoplugin_status: data.success ? 200 : 404,
  //           geoplugin_city: data.city || "",
  //           geoplugin_region: data.region || "",
  //           geoplugin_regionName: data.region || "",
  //           geoplugin_regionCode: data.region_code || "",
  //           geoplugin_countryName: data.country || "",
  //           geoplugin_countryCode: data.country_code || "",
  //           geoplugin_latitude: data.latitude || "",
  //           geoplugin_longitude: data.longitude || "",
  //           geoplugin_timezone: data.timezone || "",
  //         });
  //         params = formatGeoPlugin(params);
  //       } else {
  //         params = {
  //           geoplugin_request: "103.229.129.140",
  //           geoplugin_city: "Jacksonville",
  //           geoplugin_countryName: "United States",
  //           geoplugin_countryCode: "US",
  //           geoplugin_currencyCode: "USD",
  //         };
  //       }

  //       this.sharedService.setClientIpIn(params.geoplugin_request);

  //       this.geoLocationInfo = {
  //         countryName: params.geoplugin_countryName,
  //         countryCode: params.geoplugin_countryCode,
  //         cityName: params.geoplugin_city,
  //         currencyCode: params.geoplugin_currencyCode,
  //         geoPluginCode: 1,
  //       };

  //       this.sharedService.setGeoLocationParams(this.geoLocationInfo);

  //       // this.sharedService.setPreviousCurrency(
  //       //   this.geoLocationInfo.currencyCode
  //       // );
  //       if (this.button)
  //         this.renderer.setProperty(
  //           this.button.nativeElement,
  //           "textContent",

  //           this.geoLocationInfo.currencyCode + " / " + this.currenctLanguage,
  //         );
  //       console.log(
  //         this.geoLocationInfo.currencyCode,
  //         "  nagaraju 361 before set current currency",
  //       );
  //       this.sharedService.setCurrentCurrency(
  //         this.geoLocationInfo.currencyCode,
  //       );

  //       // this.setCurrencyText(this.geoLocationInfo.currencyCode, '');

  //       this.selectedGroup = this.popularCurrencysDropdown.find(
  //         (x) => x.value == this.geoLocationInfo.currencyCode,
  //       );
  //       // console.log(this.selectedGroup);

  //       if (this.selectedGroup) {
  //         // this.sharedService.setPreviousCurrency(
  //         //   this.geoLocationInfo.currencyCode
  //         // );
  //         // this.sharedService.setCurrentCurrency(
  //         //   this.geoLocationInfo.currencyCode
  //         // );
  //         // this.setCurrencyText(this.geoLocationInfo.currencyCode, "");
  //       } else {
  //         // this.sharedService.setPreviousCurrency("USD");
  //         // this.sharedService.setCurrentCurrency("USD");
  //       }

  //       this.sharedService.setCurrencyInPages();
  //       this.getOrgContactDetails(this.geoLocationInfo.countryCode);
  //     }
  //   });

  //   this.sharedService.loginSuccess$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((status) => {
  //       if (status != null && status != undefined) {
  //         this.enableLoginBtn = status;
  //         this.enableMyAccount = true;
  //       }
  //     });

  //   this.sharedService.GeoLocationParam.pipe(
  //     untilDestroyed(this),
  //     share(),
  //   ).subscribe((geoData) => {
  //     if (geoData) {
  //       this.geoLocationInfo = geoData;
  //       if (this.geoLocationInfo.countryCode) {
  //         this.commonService.getContactUsDetails({
  //           countryISO2: this.geoLocationInfo.countryCode,
  //         });
  //       } else {
  //         this.commonService.getContactUsDetails({ countryISO2: "US" });
  //       }
  //     }
  //   });

  //   this.LoginService.LanguaggeSuccess.pipe(
  //     untilDestroyed(this),
  //     share(),
  //   ).subscribe((result) => {
  //     if (result != null) {
  //       this.languagesData = result.result;
  //     }
  //   });

  //   this.commonService.CurrencyCountryIso2.pipe(
  //     untilDestroyed(this),
  //     share(),
  //   ).subscribe((currency) => {
  //     if (currency && currency.result) {
  //       this.geoLocationInfo.currencyCode = currency.result[0].shortname;
  //       this.sharedService.setGeoLocationParams(this.geoLocationInfo);

  //       // console.log(JSON.stringify(this.popularCurrencysDropdown), this.geoLocationInfo.currencyCode)
  //       // console.log(this.popularCurrencysDropdown.find(x => x.value == this.geoLocationInfo.currencyCode));

  //       this.selectedGroup = this.popularCurrencysDropdown.find(
  //         (x) => x.value == this.geoLocationInfo.currencyCode,
  //       );
  //       // console.log(this.selectedGroup);
  //       this.renderer.setProperty(
  //         this.button.nativeElement,
  //         "textContent",

  //         this.geoLocationInfo.currencyCode + " / " + this.currenctLanguage,
  //       );
  //       console.log("inside of before set currency  nagaraju ");
  //       this.sharedService.setCurrentCurrency(
  //         this.geoLocationInfo.currencyCode,
  //       );

  //       if (this.selectedGroup) {
  //         // this.sharedService.setPreviousCurrency(
  //         //   this.geoLocationInfo.currencyCode
  //         // );
  //         // this.sharedService.setCurrentCurrency(
  //         //   this.geoLocationInfo.currencyCode
  //         // );

  //         console.log(
  //           this.geoLocationInfo.currencyCode + " / " + this.currenctLanguage,
  //           "   nagaraju",
  //         );
  //       } else {
  //         // this.sharedService.setPreviousCurrency("USD");
  //         // this.sharedService.setCurrentCurrency("USD");
  //       }
  //       this.sharedService.setCurrencyInPages();
  //     }
  //   });

  //   this.commonService.OrgContactSuccess$.pipe(
  //     untilDestroyed(this),
  //     share(),
  //   ).subscribe((orgdtls) => {
  //     if (orgdtls != undefined && orgdtls != null) {
  //       this.ytbseoService.setOrgContactMetaDtls(orgdtls.result);
  //     }
  //   });

  //   this.sharedService.previousCurrencyParam$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((params) => {
  //       if (params) {
  //         this.previousCurrency = params;
  //       }
  //     });

  //   this.sharedService.currenctCurrencyParam$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((curCurr) => {
  //       console.log(
  //         curCurr,
  //         "   nagaraju  current currency ",
  //         this.button,
  //         this.button?.nativeElement,
  //       );
  //       if (curCurr) {
  //         this.currentCurrency = curCurr;
  //         if (this.button) {
  //           console.log(this.button);
  //           this.renderer.setProperty(
  //             this.button.nativeElement,
  //             "textContent",

  //             this.currentCurrency + " / " + this.currenctLanguage,
  //           );
  //         }
  //       }
  //     });

  //   this.sharedService.tempcurencySet$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((tempRes) => {
  //       this.setCurrencyText(this.currentCurrency, "");
  //     });

  //   // this.commonService.errorSuccess
  //   //   .pipe(untilDestroyed(this), share())
  //   //   .subscribe((error) => {
  //   //     if (error.status && error.loglevel == "Error") {
  //   //       this.router.navigate(["error"], {
  //   //         queryParams: {
  //   //           module: "FT",
  //   //           code: "GEN_ERR",
  //   //           message: ["Something went wrong"],
  //   //         },
  //   //       });
  //   //     }
  //   //   });

  //   /**
  //    * This function is used to get GeoLocation data from latitude and longitude if user enables location
  //    * otherwise it will takes data from user IP address and stores that information in session
  //    */
  //   if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
  //     if (window.navigator && window.navigator.geolocation) {
  //       window.navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           setTimeout(() => {
  //             this.commonService.logError({
  //               logLevel: "Info",
  //               message:
  //                 "Enlabled Location " +
  //                 this.tempReferenceId +
  //                 JSON.stringify(position),
  //             });
  //           }, 200);

  //           // console.log('in geo loc position');
  //           this.displayLocationInfo(position);
  //         },
  //         (error) => {
  //           setTimeout(() => {
  //             this.commonService.logError({
  //               logLevel: "Info",
  //               message:
  //                 "Disabled Location " +
  //                 this.tempReferenceId +
  //                 JSON.stringify(error),
  //             });
  //           }, 200);

  //           this.commonService.getCurrencybyCountryIso2(
  //             this.geoLocationInfo.countryCode,
  //           );
  //           this.geoLocationInfo.countryCode = "US";

  //           this.geoLocationInfo.countryName = "United States";

  //           this.geoLocationInfo.cityname = "Jacksonville";

  //           this.geoLocationInfo.geoPluginCode = 2;

  //           this.sharedService.setGeoLocationParams(this.geoLocationInfo);

  //           // this.sharedService.setPreviousCurrency(
  //           //   this.geoLocationInfo.currencyCode
  //           // );
  //           if (this.button)
  //             this.renderer.setProperty(
  //               this.button.nativeElement,
  //               "textContent",

  //               this.geoLocationInfo.currencyCode
  //                 ? this.geoLocationInfo.currencyCode
  //                 : "USD" + " / " + this.currenctLanguage
  //                   ? this.currenctLanguage
  //                   : "English",
  //             );
  //           console.log(
  //             this.geoLocationInfo.currencyCode,
  //             "  nagaraju 361 before set current currency",
  //           );
  //           this.sharedService.setCurrentCurrency(
  //             this.geoLocationInfo.currencyCode,
  //           );
  //           this.sharedService.setCurrencyInPages();
  //           this.getOrgContactDetails(this.geoLocationInfo.countryCode);

  //           this.commonService.getCurrencybyCountryIso2(
  //             this.geoLocationInfo.countryCode,
  //           );

  //           // console.log('in geo loc error');
  //           // this.geolocationPlugin();
  //           switch (error.code) {
  //             case 1:
  //               // console.log('Permission Denied');
  //               break;
  //             case 2:
  //               // console.log('Position Unavailable');

  //               break;
  //             case 3:
  //               // console.log('Timeout');
  //               break;
  //           }
  //         },
  //       );
  //     } else {
  //       // alert('in geo loc else');

  //       this.commonService.getCurrencybyCountryIso2(
  //         this.geoLocationInfo.countryCode,
  //       );
  //       // this.geoLocationInfo.countryCode = shortname;

  //       //     this.geoLocationInfo.countryName = longname;

  //       //     this.geoLocationInfo.cityname = shortname;

  //       this.geoLocationInfo.geoPluginCode = 2;
  //     }
  //   }

  //   this.sharedService.logOutUserId
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((status) => {
  //       if (status != undefined && status != null) {
  //         if (status) {
  //           this.sharedService.setUserIdAfterLogin(null);
  //           // localStorage.removeItem('UserObj');
  //           // localStorage.removeItem('UserID');
  //           // localStorage.removeItem('UserObj');
  //           this.sharedService.removeUserObject();
  //           this.enableLoginBtn = true;
  //           this.enableMyAccount = false;
  //           if (this.router.url == "/my-account") {
  //             this.router.navigate([""]);
  //           }
  //           this.authService.signOut(); // for social logout
  //           this.router.navigate([""]);
  //           if (
  //             this.router.url == "/my-account" ||
  //             this.router.url == "/change-password"
  //           ) {
  //             this.router.navigate([""]);
  //           }
  //         }
  //       }
  //     });

  //   this.commonService.token$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((token) => {
  //       if (token != null && token != undefined) {
  //         this.sharedService.setToken(token);
  //       }
  //     });

  //   this.sharedService.closeModalWindowAfterLogin$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((token) => {
  //       if (token != null && token != undefined) {
  //         if (this.ref) this.ref.close();
  //       }
  //     });

  //   // this.sharedService
  //   // .token$.pipe(takeUntil(componentDestroyed(this)),share())
  //   // .subscribe(token=>{
  //   //   if(token!=null && token!=undefined){

  //   //     // console.log(token,'----- @@@@@@@@@@@@ ',helper.isTokenExpired(token))
  //   //   if(helper.isTokenExpired(token)){
  //   //     this.getToken();
  //   //   }else{
  //   //     this.token = token;
  //   //   }
  //   //   }else{
  //   //     this.getToken();
  //   //   }
  //   // })

  //   this.myBrowser();

  //   this.sharedService.closeMenuFromOtherService$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((status) => {
  //       if (status != null && status != undefined) {
  //         this.closeMenuButtonFromOthers();
  //       }
  //     });

  //   // this.sharedService.flightResultsAreProcessing.pipe(untilDestroyed(this), share())
  //   //   .subscribe((status: boolean) => {
  //   //     if (status != null && status != undefined) {
  //   //       this.isDisableCurrency = status;
  //   //     }
  //   //   });

  //   // this.router.events.subscribe((e: any) => {
  //   //   if (e instanceof NavigationEnd) {

  //   //     if ((e.url.includes('/book/flight')) || (e.url.includes('/flight-details')) || (e.url.includes('/search/flights'))) {
  //   //       this.isDisableCurrency = true;
  //   //     } else {
  //   //       this.isDisableCurrency = false;
  //   //     }
  //   //   }
  //   // });

  //   this.myBrowser();

  //   this.sharedService.closeMenuFromOtherService$
  //     .pipe(untilDestroyed(this), share())
  //     .subscribe((status) => {
  //       if (status != null && status != undefined) {
  //         this.closeMenuButtonFromOthers();
  //       }
  //     });

  //   this.sharedService.navigateToSignupFromSigningPage
  //     .pipe(untilDestroyed(this))
  //     .subscribe((browser) => {
  //       console.log(browser, "   576 ");
  //       if (browser) {
  //         this.goToRegister();
  //       }
  //     });

  //   this.sharedService.navigateToAgentSignupFromSigningPage
  //     .pipe(untilDestroyed(this))
  //     .subscribe((browser) => {
  //       console.log(browser, "   622 ");
  //       if (browser) {
  //         this.gotoAgentSignup();
  //       }
  //     });

  //   this.sharedService.navigateToSigninFromSignupPage
  //     .pipe(untilDestroyed(this))
  //     .subscribe((browser) => {
  //       console.log(browser, "   585 ");
  //       if (browser) {
  //         // console.log("  Sign up to sign in    ");
  //         this.loadSignInComponent();
  //       }
  //     });
  // }

  openLinkOnTab(linkToOpen) {
    if (this.router.url.includes("search/flights") || this.router.url.includes("lp/flights") || this.router.url.includes("flight-details") || this.router.url.includes("book/flight")) {
      // When user is in pages of Flight Booking Pages

      let url = this.router.createUrlTree([linkToOpen]);

      if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
        window.open(url.toString(), "_blank");
      }
    } else {
      // When user is in other pages except Flight Booking Pages

      this.router.navigateByUrl(linkToOpen);
    }
  }

  epicFunction() {
    console.log("hello `Home` component");
    this.deviceInfo.set(this.deviceService.getDeviceInfo());
    this.isMobile.set(this.deviceService.isMobile());
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    console.log(this.deviceInfo());
    console.log(isTablet); // returns if the device us a tablet (iPad etc)
    console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.

    this.sharedService.setIsMobileOrNOtFlag(this.isMobile());
  }

  myBrowser() {
    // console.log(navigator.userAgent)
    // if (
    //   (navigator.userAgent.indexOf("Opera") ||
    //     navigator.userAgent.indexOf("OPR")) != -1
    // ) {
    //   return "Opera";
    // } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    //   return "Chrome";
    // } else if (navigator.userAgent.indexOf("Safari") != -1) {
    //   return "Safari";
    // } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    //   return "Firefox";
    // } else if (navigator.userAgent.indexOf("MSIE") != -1) {
    //   return "IE";
    // } else {
    //   return "unknown";
    // }
  }

  ngAfterViewInit() {
    // this.renderer.setProperty(
    //   this.language.nativeElement,
    //   'textContent',
    //   this.currenctLanguage
    // );

    if (this.button()) {
      console.log(this.button());
      this.renderer.setProperty(
        this.button().nativeElement,
        "textContent",

        this.currentCurrency() + " / " + this.currenctLanguage(),
      );
    }

    setTimeout(() => {
      console.log(this.router.url);
      if (this.router.url.includes("/book/flight") || this.router.url.includes("/flight-details") || this.router.url.includes("/search/flights")) {
        this.isDisableCurrency.set(true);
      } else {
        this.isDisableCurrency.set(false);
      }
    }, 1000);
  }

  loadSignInComponent() {
    // this.signincontainer.clear();
    // const factory = this.resolver.resolveComponentFactory(LoginComponent);
    // this.signincontainer.createComponent(factory);

    if (
      this.router.url.includes("search/flights") ||
      this.router.url.includes("lp/flights") ||
      this.router.url.includes("flight-details") ||
      this.router.url.includes("book/flight") ||
      this.router.url.includes("coupons")
    ) {
      // When user is in pages of Flight Booking Pages
      if (this.ref()) this.ref().close();
      setTimeout(() => {
        this.ref.set(
          this.dialogService.open(UserComponent, {
            width: "70%",
            contentStyle: { overflow: "auto" },
            baseZIndex: 10000,
            data: { fromModal: true },
          }),
        );
      });
    } else {
      // if (!this.router.url.includes('SignupAgent')) {
      //   // let url = this.router.createUrlTree(['SigninUser']);
      //   // if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      //   //   window.open(url.toString(), "_blank");
      //   // }
      //   this.router.navigate(['SigninUser']);
      // } else {
      this.router.navigate(["SigninUser"]);
      // }
    }
  }

  closePopUp() {
    if (this.closebtn()) {
      this.closebtn().nativeElement.click();
    }
  }

  gotoAgentSignup() {
    if (
      this.router.url.includes("search/flights") ||
      this.router.url.includes("lp/flights") ||
      this.router.url.includes("flight-details") ||
      this.router.url.includes("book/flight") ||
      this.router.url.includes("coupons")
    ) {
      // When user is in pages of Flight Booking Pages
      if (this.ref()) this.ref().close();
      setTimeout(() => {
        this.ref.set(
          this.dialogService.open(AgentComponent, {
            width: "70%",
            contentStyle: { overflow: "auto" },
            baseZIndex: 10000,
            data: { fromModal: true },
          }),
        );
      });
    } else {
      this.router.navigate(["SignupAgent"]);
    }
  }

  goToRegister() {
    // if (this.signupbtn) {
    //   this.signupbtn.nativeElement.click();
    // }

    // this.signupcontainer.clear();
    // const factory = this.resolver.resolveComponentFactory(SignUpComponent);
    // this.signupcontainer.createComponent(factory);

    if (
      this.router.url.includes("search/flights") ||
      this.router.url.includes("lp/flights") ||
      this.router.url.includes("flight-details") ||
      this.router.url.includes("book/flight") ||
      this.router.url.includes("coupons")
    ) {
      // When user is in pages of Flight Booking Pages
      if (this.ref()) this.ref().close();
      setTimeout(() => {
        this.ref.set(
          this.dialogService.open(UserSignupComponent, {
            width: "70%",
            contentStyle: { overflow: "auto" },
            baseZIndex: 10000,
            data: { fromModal: true },
          }),
        );
      });
    } else {
      // if (!this.router.url.includes('SigninUser')) {
      //   // let url = this.router.createUrlTree(['SignupAgent']);
      //   // if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      //   //   window.open(url.toString(), "_blank");
      //   // }
      //   this.router.navigate(['SignupAgent']);
      // } else {
      this.router.navigate(["SignupUser"]);
      // }
    }
  }

  /**
   *
   * @param langcode
   * @param langname
   * This function is used to set selected language on dropdown
   */
  onLangClick(langcode, langname) {
    if (isPlatformBrowser(this.platformId) && typeof window !== "undefined") {
      var jObj = jQuery(".goog-te-combo");
      jObj.val(langcode);
      var db = jObj.get(0);
      console.log(db);
      if (db) {
        this.triggerHtmlEvent(db, "change");
        // this.renderer.setProperty(
        //   this.language.nativeElement,
        //   'textContent',
        //   langname
        // );
        //  console.log(this.currentCurrency + " / " + langname,"   nagaraju")
        // this.renderer.setProperty(
        //   this.button.nativeElement,
        //   "textContent",
        //   this.currentCurrency + " / " + langname
        // );
        this.sharedService.setCurrentLanguagge(langname);
      }
    }
  }

  /**
   *
   * @param element
   * @param eventName
   *
   * This function is used to fire event for Language conversion
   */
  triggerHtmlEvent(element, eventName) {
    if (isPlatformBrowser(this.platformId) && element) {
      var event;
      if (this.document.createEvent) {
        event = this.document.createEvent("HTMLEvents");
        event.initEvent(eventName, true, true);
        element.dispatchEvent(event);
      } else {
        // event = this.document.createEventObject();
        // event.eventType = eventName;
        // element.fireEvent("on" + event.eventType, event);
      }
    }
  }

  /**
   * If user not allows location it will call and fetch address from ip address.
   */
  // geolocationPlugin() {
  //   this.commonService.SupplierManagerMappingDetails.pipe(
  //     untilDestroyed(this)
  //   ).subscribe((mappings) => {
  //     if (mappings != undefined && mappings != null) {
  //       let Credentials: Array<any> = mappings.result;
  //       this.fetchIpAddressUrl =
  //         Credentials[
  //           Credentials.findIndex((i) => i.name === "geopluginurl")
  //         ].value;

  //       this.commonService.getDatausingGeoPlugin(this.fetchIpAddressUrl);
  //       if (this.tempReferenceId)
  //         setTimeout(() => {
  //           this.commonService.logError({
  //             loglevel: "Info",
  //             message:
  //               " IpAddress for user -   " +
  //               this.tempReferenceId +
  //               JSON.stringify(this.fetchIpAddressUrl),
  //           });
  //         }, 200);
  //       // this.commonService.getIp(this.fetchIpAddressUrl);
  //     }
  //   });
  // }

  /**
   * If user  allows location it will call and fetch address from latitude and longitude.
   */
  displayLocationInfo = (position) => {
    this.commonService.getAddressFromLatLng(position, (response) => {
      this.geoLocationResponse.set(response);
      if (this.geoLocationResponse() != null) {
        for (var i = 0; i < this.geoLocationResponse()[0].address_components.length; i++) {
          var shortname = this.geoLocationResponse()[0].address_components[i].short_name;
          var longname = this.geoLocationResponse()[0].address_components[i].long_name;
          var type = this.geoLocationResponse()[0].address_components[i].types;
          if (type.indexOf("country") != -1) {
            if (!this.commonService.isNullOrWhitespace(shortname)) {
              this.geoLocationInfo().countryCode = shortname;
              this.getOrgContactDetails(this.geoLocationInfo().countryCode);
            } else {
              this.geoLocationInfo().countryName = longname;
            }
          }
          if (type.indexOf("locality") != -1) {
            if (!this.commonService.isNullOrWhitespace(shortname)) {
              this.geoLocationInfo().cityname = shortname;
            } else {
              this.geoLocationInfo().cityname = shortname;
            }
          }
          if (this.geoLocationResponse()[0].address_components.length - 1 === i) {
            this.commonService.getCurrencybyCountryIso2(this.geoLocationInfo().countryCode);
          }
        }

        this.geoLocationInfo().geoPluginCode = 2;
      }
    });
  };

  logout() {
    // localStorage.removeItem('UserObj');
    // localStorage.removeItem('UserID');
    // localStorage.removeItem('LoggegIn');

    this.sharedService.removeUserObject();
    this.sharedService.removeLoggedObject();
    this.enableLoginBtn.set(true);

    this.sharedService.loginUserId.next(null);
    this.sharedService.removeUserIdAfterLogout();
  }

  /**
   * This function is used to get all languagges
   */
  getLanguagges() {
    this.loginService.getLanguagges();
    this.loginService.LanguaggeSuccess.pipe(untilDestroyed(this), share()).subscribe((result) => {
      this.languagesData.set(result.result);
      if (result != null) {
      }
    });
  }
  ngOnDestroy(): void {
    this.loginService.dispose();
  }

  /**
   * This function is used to get all currency's list
   */
  getCurrencyList() {
    console.log("insde= of getCurrency list %%%%%%%%%%%%%%");
    this.commonService.getPopularCurrencies();
  }

  setCurrencyText(tocurrency, from) {
    let index, finalindex;
    index = this.normalCurrencys().findIndex((item) => item.symbol === tocurrency);
    finalindex = this.popularCurrencys().findIndex((item) => item.symbol === tocurrency);
    if (finalindex >= 0) {
      this.selectedGroup.set(this.popularCurrencysDropdown().find((x) => x.value == tocurrency));
      // console.log(tocurrency + " / " + this.currenctLanguage, "   nagaraju");
      // this.renderer.setProperty(
      //   this.button.nativeElement,
      //   "textContent",
      //   tocurrency + " / " + this.currenctLanguage
      // );
    }
  }

  /**
   *
   * @param tocurrency
   * @param type
   * This function is used set selected currency
   */
  getCurrencyName(tocurrency, type) {
    // console.log(JSON.stringify(tocurrency), this.selectedGroup);

    // tocurrency = this.selectedGroup.value;
    this.setCurrencyText(tocurrency, "by change of currency ");

    if (this.router.url.includes("/book/flight") || this.router.url.includes("/flight-details") || this.router.url.includes("/search/flights")) {
      console.log("If it is other than Booking Flow of Flight we dont want to update Current Currency ");
      console.log("It will effect the loading behaviour ");
    } else {
      this.renderer.setProperty(
        this.button().nativeElement,
        "textContent",

        tocurrency + " / " + this.currenctLanguage(),
      );
      let prevCurrency = this.currentCurrency;
      console.log("inside of before set currency  nagaraju ");

      this.sharedService.setCurrentCurrency(tocurrency);
      this.sharedService.setPreviousCurrency(prevCurrency);
      this.commonService.updateCurrencyValues(prevCurrency, tocurrency);
      this.sharedService.isCurrencyLoading.emit(true);
    }
  }

  getOrgContactDetails(ctrycode: string) {
    this.commonService.getContactUsDetailsByISO2(ctrycode);
  }

  over() {
    if (this.hidecurrency().nativeElement.classList.contains("hidecurrency0")) {
      this.renderer.removeClass(this.hidecurrency().nativeElement, "hidecurrency0");
    } else {
      this.renderer.addClass(this.hidecurrency().nativeElement, "hidecurrency0");
    }
  }

  closeMenuButtonFromOthers() {
    if (this.closeMenuButton && this.closeMenuButton().nativeElement) {
      this.closeMenuButton().nativeElement.click();
    }
  }

  navigateToHome() {
    // setTimeout(() => {
    // this.router.navigate([""]);
    this.router.navigate([""]).then(() => {
      if (isPlatformBrowser(this.platformId)) {
        window.location.reload();
      }
    });
    //   if (isPlatformBrowser(this.platformId)) {
    //     window.location.reload();
    //   }
    // }, 2000);
  }
}
